import { defineMessages } from "@/i18n";
import en from "./en";

export const authMessages = defineMessages("auth", en);
